import { get } from "../../service/api";

const GetMerchantSummaryCount = async (merchantId) => {
    try {
        const response = await get(`/admin/merchantSummaryCount?merchantId=${merchantId}`);
        return response.data;
    } catch (error) {
        console.error('Error GetMerchantSummaryCount:', error);
        throw error;
    }
};

export default GetMerchantSummaryCount;